import { render, staticRenderFns } from "./CallbackForm.vue?vue&type=template&id=ed744ff0&"
import script from "./CallbackForm.vue?vue&type=script&lang=js&"
export * from "./CallbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports